import { atom } from "jotai";

export const newCropBoxAtom = atom<any | null>(null);